import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import React from "react";
import { useState, useEffect, useRef } from "react";
import Instance from "../../Utils/Axios";
import "./ProfileLayout.css";
import { showToast } from "../../Utils";
import axios from "axios";
import Select from "react-select";

export default function MyProfile() {
  const [activeTab, setActiveTab] = useState(1);
  // const [profileData, setProfileData] = useState([]);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [selectedImage, setSelectedImage] = useState("/build/Profile_Pic.svg");
  const fileInputRef = useRef(null);
  const [fileData, setFile] = useState(null);
  const [countryList, setCountryList] = useState([]);

  const fetchCountryList = () => {
    Instance.post("/user/common/countryList", {
      status: "ACTIVE",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          const filteredCountries = response.data.message.filter(
            (country) => country.countryName.trim() !== ""
          );
          setCountryList(filteredCountries);
        } else {
          console.error("Error fetching countries list:", response.data.resMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching countries list:", error);
      });
  };

  useEffect(() => {
    const fetchProfileData = () => {
      const token = localStorage.getItem("tokenId");
      Instance.post("/user/profile", {
        // tokenId: token,
      })
        .then((response) => {
          // setProfileData(response.data.userProfile);
          setFormData(response.data.userProfile);
          setSelectedImage(response.data.userProfile.imageUrl);
          setError("");
        })
        .catch((error) => {
          setError("Cannot fetch the data");
          console.error("Cannot fetch the profile data", error);
        });
    };
    fetchProfileData();
    fetchCountryList();
  }, []);

  const handleFileChangeLogo = (event) => {
    const token = localStorage.getItem("tokenId");
    const file = event.target.files[0];
    const formDataToSubmit = new FormData();
    // formDataToSubmit.append("tokenId", token);
    formDataToSubmit.append("fileUpload", file);

    axios.post("/site/upload/documents", formDataToSubmit, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (response?.data?.resCode == "200") {
          setSelectedImage(response?.data?.documentUrl);
          showToast(response?.data?.resMessage, "success", "success");
        } else {
          showToast(response?.data?.resMessage, "danger", "error");
        }
      })
      .catch((error) => {
        setError("Failed to upload the image");
        console.error("Error uploading image:", error);
      });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        // setFormData((prevData) => ({
        //   ...prevData,
        //   imageUrl: reader.result,
        // }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (validationErrors[name]) {
      setValidationErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const errors = {};
    if (!formData.firstName || !formData.firstName.trim()) errors.firstName = "First Name is required";
    if (!formData.lastName || !formData.lastName.trim()) errors.lastName = "Last Name is required";
    if (!formData.isdCode) errors.isdCode = "Country Code is required";
    if (!formData.mobile) errors.mobile = "Phone Number is required";
    if (!formData.country) errors.country = "Country is required";

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    setValidationErrors({});

    const token = localStorage.getItem("tokenId");
    Instance.post("/user/updateUser", {
      // tokenId: token,
      ...formData,
      imageUrl: selectedImage,
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          showToast("Updated Succesfully!", "success", "success");
          // console.log(response.data);
        } else {
          setError(response.data.resMessage);
        }
      })
      .catch((error) => {
        setError("Cannot update the profile");
        console.error("Update profile error", error);
      });
  };

  const getSelectStyles = (error) => ({
    control: (base, state) => ({
      ...base,
      borderRadius: "8px",
      borderColor: error ? "#dc3545" : (state.isFocused ? "#585edb" : "#e0e0e0"),
      boxShadow: "none",
      "&:hover": {
        borderColor: error ? "#dc3545" : "#585edb",
      },
      minHeight: "48px",
      backgroundColor: "#fbfbfb",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "200px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#585edb"
        : state.isFocused
          ? "#f1f2fd"
          : "transparent",
      color: state.isSelected ? "white" : "#091e42",
      "&:active": {
        backgroundColor: "#585edb",
      },
    }),
  });

  return (
    <>
      <div className="secondary_nav">
        <div
          className={`secondary_tabs ${activeTab === 1 ? "path_active" : ""}`}
          onClick={() => setActiveTab(1)}
        >
          My Profile
        </div>
      </div>

      <div className="content_container mb-5">
        <div className="edit_container px-5 mb-5">
          <h5 >Add Profile Picture</h5>
          <div className="upload">
            <div className="profile_picture_box">
              {selectedImage && selectedImage !== "/build/Addimage.svg" ? (
                <img
                  className="profile_picture real_image"
                  src={selectedImage}
                  alt="Profile picture"
                  onError={(e) => { e.currentTarget.src = '/build/Addimage.svg'; e.currentTarget.className = 'profile_picture placeholder_image'; }}
                />
              ) : (
                <img
                  className="profile_picture placeholder_image p-4 opacity-50"
                  src="/build/Addimage.svg"
                  alt="Add image"
                  onClick={() => fileInputRef.current?.click()}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </div>

            <div className="browse_image">
              <img
                className="add_picture"
                src="/build/Addimage.svg"
                alt="Add image icon"
                onClick={() => fileInputRef.current?.click()}
              />

              <h6 onClick={() => fileInputRef.current?.click()}>
                Click to upload <span className="light_text">or drag and drop PNG or JPG here.</span><br />
                Max size 2MB.
              </h6>

              <button
                className="browse_btn"
                onClick={() => fileInputRef.current?.click()}
              >
                Browse
              </button>

              <input
                ref={fileInputRef}
                type="file"
                accept="image/png,image/jpeg,image/jpg"
                style={{ display: "none" }}
                onChange={handleFileChangeLogo}
              />
            </div>
          </div>
        </div>
        <div className="px-5">
          <Form className="custom-form">
            <Row className="custom-row mb-4">
              <Form.Group as={Col} className="custom-col">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.firstName}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.firstName}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.lastName}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.lastName}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="custom-row">
              <Col xs={12} md={6} className="custom-col mb-4">
                <Form.Label>Email Id</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  readOnly
                  placeholder="Email Id"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Col>
              <Col xs={6} md={2} className="custom-col mb-4">
                <Form.Label>Country Code</Form.Label>
                <Select
                  options={countryList.map((country) => ({
                    value: country.isdCode,
                    label: country.isdCode,
                    countryCode: country.countryCode,
                  }))}
                  formatOptionLabel={({ label, countryCode }) => (
                    <div className="d-flex align-items-center">
                      <img
                        src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                        alt=""
                        className="me-2"
                        style={{ width: "20px", height: "auto" }}
                      />
                      <span>{label}</span>
                    </div>
                  )}
                  placeholder="Select"
                  isSearchable
                  classNamePrefix="react-select"
                  value={
                    formData.isdCode
                      ? {
                        value: formData.isdCode,
                        label: formData.isdCode,
                        countryCode: countryList.find(c => c.isdCode === formData.isdCode)?.countryCode || "",
                      }
                      : null
                  }
                  onChange={(val) => {
                    setFormData(prev => ({ ...prev, isdCode: val.value }));
                    if (validationErrors.isdCode) {
                      setValidationErrors(prev => ({ ...prev, isdCode: null }));
                    }
                  }}
                  styles={getSelectStyles(validationErrors.isdCode)}
                />
                {validationErrors.isdCode && <div className="text-danger small mt-1">{validationErrors.isdCode}</div>}
              </Col>
              <Col xs={6} md={4} className="custom-col mb-4">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Mobile Number"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.mobile}
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.mobile}
                </Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="custom-row mb-4">
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Country</Form.Label>
                <Select
                  options={countryList.map((country) => ({
                    value: country.countryName,
                    label: country.countryName,
                    countryCode: country.countryCode,
                  }))}
                  formatOptionLabel={({ label, countryCode }) => (
                    <div className="d-flex align-items-center">
                      <img
                        src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                        alt=""
                        className="me-2"
                        style={{ width: "20px", height: "auto" }}
                      />
                      <span>{label}</span>
                    </div>
                  )}
                  placeholder="Select Country"
                  isSearchable
                  classNamePrefix="react-select"
                  value={
                    formData.country
                      ? {
                        value: formData.country,
                        label: formData.country,
                        countryCode: countryList.find(c => c.countryName === formData.country)?.countryCode || "",
                      }
                      : null
                  }
                  onChange={(val) => {
                    setFormData(prev => ({
                      ...prev,
                      country: val.value,
                      isdCode: countryList.find(c => c.countryName === val.value)?.isdCode || prev.isdCode
                    }));
                    if (validationErrors.country) {
                      setValidationErrors(prev => ({ ...prev, country: null }));
                    }
                    if (validationErrors.isdCode) {
                      setValidationErrors(prev => ({ ...prev, isdCode: null }));
                    }
                  }}
                  styles={getSelectStyles(validationErrors.country)}
                />
                {validationErrors.country && <div className="text-danger small mt-1">{validationErrors.country}</div>}
              </Form.Group>
            </Row>
            <Row className="custom-row mb-4">
              <Form.Group as={Col} className="custom-col">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter new password"
                  name="pwd"
                  value={formData.pwd}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmpwd"
                  placeholder="Enter confirm password"
                  value={formData.confirmpwd}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="custom-row mb-4">
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your company name"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Company Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your company address"
                  name="companyAddress"
                  value={formData.companyAddress}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="custom-row mb-4">
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Company Website</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your company website"
                  name="companyWebsite"
                  value={formData.companyWebsite}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="custom-col">
                <Form.Label>Other Details</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter other details"
                  name="otherDetails"
                  value={formData.otherDetails}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
          </Form>
        </div>
        <div className="change_buttons">
          <button className="save_btn mb-4" onClick={handleSubmit}>
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
}
